import { Tool } from '@/util/tool'
const tool = new Tool()

const Authentication = {
  matchElementPrivilege (userAuthenticationCode, elementCode, value) {
    for (const item of userAuthenticationCode) {
      if (Object.prototype.hasOwnProperty.call(item, 'code') && item.code === elementCode && ((item.privilege & value) === value)) {
        return true
      }
    }
    return false
  },

  matchRestricts (restricts, loanStatus) {
    for (const item of restricts) {
      if (Object.prototype.hasOwnProperty.call(item, 'loanStatus') && item.loanStatus === loanStatus) {
        return true
      }
    }
    return false
  },

  isLockedByCurrentUser (currentAccount, actualLockedId) {
    if (tool.isNotEmpty(currentAccount) && tool.isNotEmpty(actualLockedId)) {
      return currentAccount.id === actualLockedId
    }
    return false
  },

  matchElementButtonList (buttonList, buttonCode) {
    if (tool.isNotEmpty(buttonList)) {
      for (const item of buttonList) {
        if (item.code === buttonCode) {
          return true
        }
      }
    }
    return false
  }
}

export default Authentication
